/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stack } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { removeFileExtension } from '../../../../../util/helpers';
import TextField from '../../../../forms/TextField';
import Link from '../Link';

export default function RawVideoS3Path() {
  const { getValues, setValue } = useFormContext();

  const onS3UploadSuccess = (links, path, files) => {
    // If there is no name, then use the filename without extension as the name
    const fileNameWithoutExtension = removeFileExtension(files[0].name);
    const name = getValues('name');
    if (!name) {
      setValue('name', fileNameWithoutExtension);
    }

    const adTitle = getValues('videoAd.adTitle');
    if (!adTitle) {
      setValue('videoAd.adTitle', fileNameWithoutExtension);
    }
  };

  const onVideoLoadedData = (duration) => {
    setValue('videoAd.duration', duration);
  };

  const onRemoveSuccess = () => {
    setValue('videoAd.duration', null);
  };

  return (
    <Stack spacing={2}>
      <Link
        fieldName="videoAd.rawVideoS3Path"
        s3InfoUrl="/admin/helpers/s3_upload_info/ventura_video"
        accept=".mp4"
        helpText={<p>Note: Select the file containing the video file.</p>}
        onSuccess={onS3UploadSuccess}
        onVideoLoadedData={onVideoLoadedData}
        onRemoveSuccess={onRemoveSuccess}
      />
      <TextField name="videoAd.rawVideoS3Path" label="Raw Video S3 Path" inputProps={{ readOnly: true }} />
    </Stack>
  );
}
